import request from '@/utils/zsm-requets'
const douyin = '/zsm/api/user/douyin/'
const douyin2 = '/zsm/kapi/user/douyin/'
/**
 *  获取抖音基本信息
 */
export function getDouyinInfo(id) {
  return request({
    url: douyin + 'get',
    method: 'post',
    params: { id }
  })
}

/**
 * 获取用户是否授权
 @param frontId     //前端id
 */
export function validDouyin(frontId) {
  return request({
    url: douyin + 'valid',
    method: 'post',
    params: { frontId }
  })
}

export function validDouyin2(frontId) {
  return request({
    url: douyin2 + 'valid',
    method: 'post',
    params: { frontId }
  })
}

